import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { IconType } from '@/modules/ui';
import { hasWritePermission } from '@/utilities/permission';

import { ListItemType } from '../../constants';
import type { SecurityAuditLevelItem } from '../../types';
import { IgnoreIndicator } from '../IgnoreIndicator';
import { SecurityAuditGroupItem } from '../SecurityAuditGroupItem';
import { SecurityAuditItemRenderer, type SecurityAuditItemRendererProps } from '../SecurityAuditItemRenderer';
import { SecurityAuditSecretItem } from '../SecurityAuditSecretItem';
import { iconTypeBySecurityLevel } from './types';

export interface SecurityAuditLevelItemRendererProps extends Omit<SecurityAuditItemRendererProps<SecurityAuditLevelItem>, 'children'> {}

const NO_SECURITY_LEVEL = 'noSecurityLevel';

export const SecurityAuditLevelItemRenderer = (props: SecurityAuditLevelItemRendererProps) => (
    <SecurityAuditItemRenderer<SecurityAuditLevelItem> {...props}>
        {({ item, isFirstGroup, isLastInGroup }) => (
            <>
                {item.listItemType === ListItemType.GROUP ? (
                    <SecurityAuditGroupItem
                        name={<FormattedMessage id={`password.strength.${item.securityLevel ?? NO_SECURITY_LEVEL}`} />}
                        count={item.count}
                        isFirstGroup={isFirstGroup}
                    />
                ) : (
                    <SecurityAuditSecretItem
                        id={item.id}
                        name={item.name}
                        canEdit={hasWritePermission(item.userPermissions)}
                        icon={
                            !item.ignoreSecurityReport
                                ? item.securityLevel !== undefined
                                    ? iconTypeBySecurityLevel[item.securityLevel]
                                    : IconType.STATUS_NO_PASS
                                : undefined
                        }
                        isLastInGroup={isLastInGroup}
                        updateSecretRoute={config.routes.securityAuditLevelUpdateSecret}
                        additional={item.ignoreSecurityReport ? <IgnoreIndicator /> : null}
                    />
                )}
            </>
        )}
    </SecurityAuditItemRenderer>
);
